import { PartnerPortalConfig } from './partner-portal-config';
import { PortalType } from './portal-type';

//Config specific to partner center portal
export class PartnerMPPortalConfig extends PartnerPortalConfig {
  portalName = PortalType.Partner;
  preferencesApplicable = true;
  woboApplicable = true;
  signInPath = `/aad-multiportal?action=signin&returnPath=${document.location.origin}/dashboard/v2/home?route=v2&prompt=select_account`;
  signInRedirectPath = `/aad-multiportal?action=signin&returnPath=${document.location.href}`;
  signOutPath = '/aad-multiportal?action=signout';
  useFDSurveyEndpoint = false;
  homeUrl = '/dashboard/v2/home';

  constructor() {
    super();
    this.setApiEndpoints();
  }

  setApiEndpoints() {
    this.apiEndpoints = {
      auth: '{domain}/api/user/accesstokens?tokenResources=MicrosoftGraph&tokenResources=AccountsFirstPartyApp&tokenResources=AzureResourceManager',
      preference: '{domain}/api/user/preference',
    };
  }
}
